import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { handleRequest } from "../../helpers/handleAsync";
import categoryService from "../../services/categoryService";
export interface ICategoryState {
    categoryId: number
    categoryName: string
}
const initialState: ICategoryState = {
    categoryId: 0,
    categoryName: ""
}
const getCategoryList = createAsyncThunk(
    'category/getData',
    async () => {
        const [res, err] = await handleRequest(categoryService.getCategories());
        if (!res || err) {
            throw new Error('Unknow Error');
        }
        return res.data;
    }
);
const getProductsByCategory = createAsyncThunk(
    'category/getProducts',
    async (categoryId: number) => {
        const [res, err] = await handleRequest(categoryService.getProductsByCategory(categoryId));
        if (!res || err) {
            throw new Error('Unknow Error');
        }
        return res.data;
    }
);
export const categorySlice = createSlice({
    name: 'id',
    initialState,
    reducers: {
        setCategoryActive(state, action: PayloadAction<ICategoryState>) {
            state.categoryId = action.payload.categoryId;
            state.categoryName = action.payload.categoryName
        }

    }
})
export const categoryPrvSliceActions = { getCategoryList, getProductsByCategory };
export const { setCategoryActive } = categorySlice.actions;
export default categorySlice.reducer;